import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/depop-feedback';

export default function Example() {
  return (
    <>
      <Head>
        <title>How Depop Feedbacks Can Boost Sales and Leverage Credibility</title>
        <meta
          name='description'
          content='The way to get potential buyers to make a purchase decision is to show them how reliable you are. And with this, it is critical to ensure that the process of leaving and deleting feedback on Depop is as convenient as can be. Learn how it works and get tips to help you gain 5-star ratings.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/depop-feedback' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/depop-feedback' />
        <meta property='og:title' content='How Depop Feedbacks Can Boost Sales and Leverage Credibility' />
        <meta
          property='og:description'
          content='The way to get potential buyers to make a purchase decision is to show them how reliable you are. And with this, it is critical to ensure that the process of leaving and deleting feedback on Depop is as convenient as can be. Learn how it works and get tips to help you gain 5-star ratings.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-05-15T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-05-15T00:00:00-00:00' />
        <meta property='article:tag' content='Depop' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
